import { ReactSVG } from "react-svg"
import { Assets } from "src/utils/assets"

export function BackButton(props: any){
    return <ReactSVG src={Assets.back} fill="white" onClick={props.onBackPressed} />
}